import { useRef, Suspense } from "react";
import { Canvas, useFrame } from "@react-three/fiber";
import { Points, PointMaterial, Preload } from "@react-three/drei";

const generateSpherePoints = (numPoints, radius) => {
  const points = new Float32Array(numPoints * 3);

  for (let i = 0; i < numPoints; i++) {
    const theta = Math.random() * Math.PI * 2; // Random angle around the vertical axis
    const phi = Math.acos(2 * Math.random() - 1); // Random angle from top to bottom
    const x = radius * Math.sin(phi) * Math.cos(theta);
    const y = radius * Math.sin(phi) * Math.sin(theta);
    const z = radius * Math.cos(phi);

    points[i * 3] = x;
    points[i * 3 + 1] = y;
    points[i * 3 + 2] = z;
  }

  return points;
};

// random/dist/maath-random.esm

const Stars = (props) => {
  const ref = useRef();
  const sphereRadius = 1.2;
  const numPoints = 5000;
  const spherePoints = generateSpherePoints(numPoints, sphereRadius);

  useFrame((state, delta) => {
    // @ts-expect-error TS(2532): Object is possibly 'undefined'.
    ref.current.rotation.x -= delta / 10;
    // @ts-expect-error TS(2532): Object is possibly 'undefined'.
    ref.current.rotation.y -= delta / 15;
  });

  return (
    <group rotation={[0, 0, Math.PI / 4]}>
      <Points
        ref={ref}
        positions={spherePoints}
        stride={3}
        frustumCulled
        {...props}
      >
        <PointMaterial
          transparent
          color="#f272c8"
          size={0.002}
          sizeAttenuation={true}
          depthWrite={false}
        />
      </Points>
    </group>
  );
};

const StarsCanvas = () => {
  return (
    <div className="w-full h-auto absolute inset-0 z-[-1]">
      <Canvas camera={{ position: [0, 0, 1] }}>
        <Suspense fallback={null}>
          <Stars />
        </Suspense>

        <Preload all />
      </Canvas>
    </div>
  );
};

export default StarsCanvas;
